import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchUserFriendMockData } from "../Utils/UserProfileFetchAdmirerData.js"
import POProfileImageUploader from "../Utils/ProfileImageUploader";
import "../Styles/Blogging.css"
import PageProfileModal from "../../../common/PopupPages/PageProfile";

const AdmirerProfile = ({userId, profileId}) => {
      const [admirers, setAdmirers] = useState(null);
      const [ProfileImage, setProfileImage] = useState(null);
      const [showPopup, setShowPopup] = useState(false); 
      const [renderOperation, setRenderOperation] = useState(null);
      
      useEffect(() => {
        const loadProfileData = async () => {
          const profileData = await fetchUserFriendMockData(profileId);
        
          console.log("Profile data received: ", {profileData})
          
          if (profileData) {
            setProfileImage(profileData.profileImage);
            setAdmirers(profileData?.connections?.admirers || []);
          }
        };
    
        // setShowPopup(true);
  
        if (profileId) {
          loadProfileData();
        }
      }, [profileId]);

      useEffect(() => {
        if (ProfileImage) {
          console.log("Updated profile image state:", ProfileImage);
        }
      }, [ProfileImage]);
    
      const handleUserClick = (operationType, userId) => {
        setShowPopup(false);
        setRenderOperation({
          operationType,
          data: { userId },
        });
      };

      const handleCloseModal = () => {
        setRenderOperation(null);
      };

    return (
        <div className="profile-container">
            <div className="up-blog-grid-layout" style={{width: "100%", height: "1000px", display: "flex", flexDirection: "column"}}>
                <div className="up-blog-grid-upper" style={{width: "100%", height: "20%" }}>
                <POProfileImageUploader
                    userId={userId}
                    profileImage={ProfileImage}
                    profileName={profileId}
                />       
                </div>
                <div className="up-blog-grid-lower" style={{width: "100%", height: "80%" }}>
                    {admirers?.length === 0 ? (
                        <p className="text-black">No Admirer found</p>
                    ) : (
                        admirers?.map((admirer) => (
                            <div key={admirer.userId} 
                                className="up-profile-card" 
                                style={{display: "flex", flexDirection: "column"}}
                                onClick={() => handleUserClick("open", admirer.userId)}
                            >
                                <div className="ug-profile">
                                    <img src={admirer.imageUrl} alt="Admirer" className="up-image"/>          
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
            {['open'].includes(renderOperation?.operationType) && (
      <div
        className="modal-overlay"
        style={{
          position: "fixed", // or "absolute" if you want relative to a parent
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000, // must be above all other components
        }}
      >
        <div
          style={{
            background: "#1a1a1a",
            padding: "20px",
            borderRadius: "12px",
            minWidth: "300px",
            maxWidth: "90%",
            maxHeight: "90%",
            overflowY: "auto",
          }}
        >          
          <PageProfileModal
            userId={renderOperation.data.userId}
            operationType={renderOperation.operationType}
            onClose={handleCloseModal}
          />
        </div>
      </div>
      )}
        </div>
    );
};

export default AdmirerProfile;